import type { DmPrinter } from '@nsftx/systems-sdk'
import { logService } from '@nsftx/seven-client-retail-utils'
import type { DmPrintConfigStorage } from '#src/interfaces/DmPrintConfig'
import errorParser from '#src/common/error-handling/errorParser'

const LOG_PREFIX = '[printerStorageService]'

const getSavedPrinter = (persist: DmPrintConfigStorage) => {
  const lsPrinter = getLocalStoragePrinter(persist)
  let savedPrinter: DmPrinter | undefined

  try {
    savedPrinter = JSON.parse(lsPrinter)
  } catch (error) {
    logService.warn(`${LOG_PREFIX} Cannot parse local storage printer`, {
      ...errorParser.parseUpstream(error),
      code: 'DM_PRINT_LS_PRINTER_PARSE_ERROR',
      details: {
        printer: lsPrinter
      }
    })
  }

  return savedPrinter
}

const savePrinter = (printer: DmPrinter, persist: DmPrintConfigStorage) => {
  setLocalStoragePrinter(printer, persist)
}

const getLocalStoragePrinter = (persist: DmPrintConfigStorage) => {
  const lsKey = `${persist.prefix}_settings_printer`

  return localStorage.getItem(lsKey) || ''
}

const setLocalStoragePrinter = (printer: DmPrinter, persist: DmPrintConfigStorage) => {
  const lsKey = `${persist.prefix}_settings_printer`

  localStorage.setItem(lsKey, JSON.stringify(printer))
}

export { getSavedPrinter, savePrinter }
